/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClaimClaimIdAuthenticationVerifyPost200ResponseDto } from '../models/claim-claim-id-authentication-verify-post-200-response-dto';
import { ClaimClaimIdAuthenticationVerifyPostRequestDto } from '../models/claim-claim-id-authentication-verify-post-request-dto';


/**
 * the ClaCommandAuthenticationVerification API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandAuthenticationVerificationService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdAuthenticationVerifyPost
   */
  static readonly ClaimClaimIdAuthenticationVerifyPostPath = '/claim/{claimId}/authentication/verify';

  /**
   * Verify claimant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdAuthenticationVerifyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimClaimIdAuthenticationVerifyPost$Response(params: {
    claimId: string;
    body: ClaimClaimIdAuthenticationVerifyPostRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClaimClaimIdAuthenticationVerifyPost200ResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandAuthenticationVerificationService.ClaimClaimIdAuthenticationVerifyPostPath, 'post');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClaimClaimIdAuthenticationVerifyPost200ResponseDto>;
      })
    );
  }

  /**
   * Verify claimant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdAuthenticationVerifyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimClaimIdAuthenticationVerifyPost(params: {
    claimId: string;
    body: ClaimClaimIdAuthenticationVerifyPostRequestDto
  },
  context?: HttpContext

): Observable<ClaimClaimIdAuthenticationVerifyPost200ResponseDto> {

    return this.claimClaimIdAuthenticationVerifyPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClaimClaimIdAuthenticationVerifyPost200ResponseDto>) => r.body as ClaimClaimIdAuthenticationVerifyPost200ResponseDto)
    );
  }

}
